export const arrayDiff = (a1: any[], a2: any[]): any[] => {
	return a1.filter(x => !a2.includes(x)).concat(a2.filter(x => !a1.includes(x)));
};
